import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Widerruf')
    .setChildren([
        MenuEntry.create()
            .setTitle('Offene Widerrufe')
            .setRoute('revocation_open_list')
            .setAdditionalRoutes([
                'revocation_create',
                'revocation_edit',
            ]),
        MenuEntry.create()
            .setTitle('Widerruf suchen')
            .setRoute('revocation_search'),
        MenuEntry.create()
            .setTitle('Alle Widerrufe')
            .setRoute('revocation_list')
            .setAdditionalRoutes([
                'revocation_create',
                'revocation_edit',
            ]),
        MenuEntry.create()
            .setTitle('Widerruf erstellen')
            .setRoute('revocation_create'),
        MenuEntry.create()
            .setTitle('Artikelzustand')
            .setRoute('revocation_condition_list')
            .setAdditionalRoutes([
                'revocation_condition_edit',
            ]),
        MenuEntry.create()
            .setTitle('Einstellungen')
            .setRoute('revocation_settings'),
    ]);
